import 'react-dates/initialize';
import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withRouter } from 'react-router-dom';
import { closeModal } from 'src/actions/modals';

import Modal from 'react-modal';
import ModalContainer from '../modalContainer';
import { PrimaryOutlineButton, PrimaryButton } from 'src/components/button';
import addCommunityMemberMutation from 'shared/graphql/mutations/communityMember/addCommunityMember';

import { modalStyles } from '../styles';
import { addToastWithTimeout } from 'src/actions/toasts';
import { Wrapper, H1, Message, Action } from './style';
import { Avatar } from 'src/components/avatar';

const DATA_TEST_PRE = 'join-group-modal-';
const JoinGroupModal = props => {
  const {
    isOpen,
    groupId,
    addCommunityMember,
    dispatch,
    hint,
    subHint,
  } = props;
  const styles = modalStyles(480);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {})();
  }, []);

  const close = () => dispatch(closeModal());

  const join = () => {
    const input = { communityId: groupId };
    setLoading(true);
    return addCommunityMember({ input })
      .then(({ data }) => {
        const { addCommunityMember: community } = data;
        dispatch(closeModal());
        dispatch(
          addToastWithTimeout(
            'success',
            `Welcome to the ${community.name} community!`
          )
        );
        setLoading(false);
      })
      .catch(err => {
        dispatch(addToastWithTimeout('error', err.message));
      });
  };
  return (
    <Modal
      /* TODO(@mxstbr): Fix this */
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={close}
      shouldCloseOnOverlayClick={true}
      style={styles}
      closeTimeoutMS={330}
    >
      <ModalContainer closeModal={close}>
        <Wrapper>
          <Avatar source="/img/joinGroup.png" size={150} />
          <H1>Join this group!</H1>
          <Message>{hint}</Message>
          {subHint ? <Message>{subHint}</Message> : null}
          <Action>
            <PrimaryOutlineButton
              onClick={close}
              className={['closeButton']}
              data-testid={`${DATA_TEST_PRE}close-modal`}
            >
              NO,THANKS
            </PrimaryOutlineButton>
            <PrimaryButton
              onClick={join}
              disabled={loading}
              data-testid={`${DATA_TEST_PRE}join-group`}
            >
              JOIN THIS GROUP
            </PrimaryButton>
          </Action>
        </Wrapper>
      </ModalContainer>
    </Modal>
  );
};

const map = state => ({
  isOpen: state.modals.isOpen,
});

export default compose(
  addCommunityMemberMutation,
  // $FlowIssue
  connect(map),
  withRouter
)(JoinGroupModal);
